import { Helmet, HelmetProvider } from 'react-helmet-async';
import AllContracts from "shared/components/rental/sections/all-contracts";

const AllContractsPage = () => {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Alle Contracten | Yally</title>
        </Helmet>
      </HelmetProvider>

      <AllContracts />
    </>
  );
};

export default AllContractsPage;
